import AppDatePicker from '@nxsys/components/AppDatePicker';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import moment, { Moment } from 'moment';
import React from 'react';

type ModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (date: string) => void;
  isCreditInvoicePending?: boolean;
};

type FormValues = {
  creditDate: string;
};

const CreditInvoiceModal: React.FC<ModalProps> = ({
  isOpen,
  toggle,
  onSubmit,
  isCreditInvoicePending = false,
}: ModalProps) => {
  const { messages } = useTypedIntl();

  const [form] = Form.useForm<FormValues>();

  const onFinish: FormProps['onFinish'] = (values: FormValues) => {
    const creditDate = moment(values.creditDate).toISOString();
    onSubmit(creditDate);
  };

  const onFinishFailed: FormProps['onFinishFailed'] = () => {
    // noop - form validation handles error display
  };

  return (
    <AppModalContainer
      title={messages['invoice.creditSelectedInvoice']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => form.submit(),
          loading: isCreditInvoicePending,
          disabled: isCreditInvoicePending,
        },
      ]}
      minHeight="200px"
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
      >
        <Form.Item
          key={'creditDate'}
          label={messages['common.crnDate']}
          name={'creditDate'}
        >
          <AppDatePicker
            placeholder={messages['common.selectDate']}
            onChange={(date: Moment) => {
              form.setFieldsValue({
                creditDate: date.toISOString(),
              });
            }}
            format="DD/MM/YYYY"
          />
        </Form.Item>
      </AppFormContainer>
    </AppModalContainer>
  );
};

export default CreditInvoiceModal;
